import { useState, useCallback, useEffect } from 'react'
import { useToast } from './useToast'
import { EMAIL_ACCOUNT_TYPES } from '../../mailTemplate/src/utils/campaignConstants'

export const useCampaignDrawer = (userData, t) => {
  const { showError } = useToast()

  const [isOpen, setIsOpen] = useState(false)

  const openDrawer = useCallback(() => {
    setIsOpen(true)
  }, [])

  const closeDrawer = useCallback(() => {
    setIsOpen(false)
  }, [])

  useEffect(() => {
    if (!isOpen || !userData) return

    const emailSettings = userData.emailSettings
    const isExternalService = emailSettings?.accountType === EMAIL_ACCOUNT_TYPES.EXTERNAL_SERVICE
    const hasValidEmailSettings = Boolean(emailSettings)

    if (!isExternalService && !hasValidEmailSettings) {
      showError(t('mailTemplate.campaigns.settingsMissingErr'))
    }
  }, [isOpen, userData, showError, t])

  return {
    isOpen,
    openDrawer,
    closeDrawer
  }
}
